<template>
  <div class="ui form" id="reservation-info-step">
    <div class="required field" v-if="isAbleToChangeClinic">
      <label for="reservation_type">Choose Clinic</label>
      <select
        class="ui fluid search dropdown"
        id="clinic-search"
        v-model="visit.clinic_id"
        name="doctor"
        v-if="!visit.started_at"
      >
        <option value="">Choose Clinic</option>
        <option :value="clinic.id" v-for="clinic in clinics" :key="clinic.id">
          {{ clinic.name }}
        </option>
      </select>
      <div v-else>
        {{ clinics.find(visit.clinic_id).name }}
      </div>
    </div>
    <div class="two fields">
      <div class="required field">
        <label for="reservation_type">Doctor</label>
        <select
          class="ui fluid search dropdown"
          id="doctor-search"
          v-model="visit.doctor_id"
          name="doctor"
          v-if="!visit.started_at"
        >
          <option value="">Choose Doctor</option>
          <option :value="doctor.id" v-for="doctor in doctors" :key="doctor.id">
            {{ doctor.user.name }}
          </option>
        </select>

        <div v-else>
          {{ getDoctorName() }}
        </div>
      </div>

      <div class="required field">
        <label for="reservation_type">Choose Room</label>
        <select
          class="ui fluid search dropdown"
          id="room-search"
          v-model="visit.room_id"
          name="room"
          v-if="!visit.started_at"
        >
          <option value="">Choose Room</option>
          <option :value="room.id" v-for="room in rooms" :key="room.id">
            {{ room.name }}
          </option>
        </select>

        <div v-else>
          {{ getRoomName() }}
        </div>
      </div>

      <!-- <div class="required field">
        <label for="time">Time</label>
        <div
          style="text-align: center"
          class="ui calendar"
          :id="'visitCalend' + reservation.id"
          v-if="!visit.started_at"
        >
          <div class="ui input left icon">
            <i class="calendar icon"></i>
            <input
              type="text"
              placeholder="time"
              readonly=""
              name="time"
            />
          </div>
        </div>

        <div v-else>
          {{ visit.time | moment('LLLL') }}
        </div>
      </div> -->
    </div>
    <div class="field">
      <label for="note">Note</label>
      <textarea
        name=""
        id=""
        rows="4"
        placeholder="Note"
        v-model="visit.note"
      />
    </div>

    <h4 class="ui horizontal divider header">
      Assign Packages
    </h4>
    
    <div class="ui info message" v-if="!isAllPackagesPaid && this.settings[1].value">
      <div class="header">
        There are some package can't be reserved due to not paid the limit and it's names :
      </div>
      <ul class="list" v-for="p in visit.packages" :key="p.id">
        <li v-if="!packageIsAllowedToReserve(p)">{{ p.name }}</li>
      </ul>
    </div>
    <div class="required field" style="margin-top: 30px">
      <div class="ui two column grid" v-if="visit.packages && visit.packages.length > 0">
        <template 
          v-for="(selectedPackage, index) in visit.packages" 
        >
          <div 
            :key="index + selectedPackage.package_id"
            class="column"             
            v-if="packageIsAllowedToReserve(selectedPackage)"
          >
            <div class="ui orange segment">
              <div class="centered-header">
                <h3 class="ui header" style="color: #092442;">
                  {{ selectedPackage.name }} 
                </h3>
              </div>
              <div class="ui divider" />
              <table
                class="ui center aligned celled very compact table"
                style="width: 100%"
              >
                <thead>
                  <tr>
                    <th>{{ getUnitMeasurementName(selectedPackage.unit_measurement_id) }} Quantity</th>
                    <th>{{ getUnitMeasurementName(selectedPackage.entity_unit_measurement_id) }} Quantity</th>
                    <th>Remainder</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div class="ui fluid input focus">
                        <input
                          type="number"
                          style="text-align: center"
                          :placeholder="'Repeated Quantity'"
                          v-model="selectedPackage.quantity"
                          @input="setPackages"
                          :name="index"
                          :min="1"
                        />
                      </div>
                    </td>

                    <td>
                      <div class="ui fluid input"
                        v-if="isAbleToAddActualQuantity(selectedPackage)"
                      >
                        <input
                          type="number"
                          style="text-align: center"
                          :placeholder="'Repeated Quantity'"
                          v-model="selectedPackage.actual_quantity"
                        />
                      </div>

                      <div v-else>
                        {{ selectedPackage.quantity }}
                      </div>
                    </td>

                    <td :style="getStyle(selectedPackage.remainder)">{{ selectedPackage.remainder  }}</td>
                  </tr>
                </tbody>
              </table>
            </div>         
          </div>
        </template>  
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    doctors: { type: Array, required: true },
    rooms: { type: Array, required: true },
    paidPackageIds: { type: Array, required: false },
    reservation: { type: Object, required: true },
    visits: { type: Array, required: true },
    currentVisit: { type: Object, required: true },
    setVisit: { type: Function, required: true },
    isAbleToChangeClinic: { type: Boolean, default: true }
  },
  data() {
    return {
      packages: [],
      reservationPackagesById: {},
      visitsDetailsByPackageId: {},
      visit: {
        clinic_id: this.getClinicId(),
        doctor_id: null,
        room_id: null,
        time: null,
        reservation_id: this.$route.params.reservationId,
        packages: [],
        currentPackages: []
      },
      packagesKey: 0
    }
  },
  watch: {
    visit: {
      handler: function () {
        this.setVisit(this.visit)
      },
      deep: true
    }
  },
  computed: {
    isAllPackagesPaid() {
      return this.paidPackageIds.length === this.visit.packages.length 
    }
  },
  mounted () {
    this.visit = window._.cloneDeep(this.currentVisit)
    this.packages = this.reservation.reservations_packages.map(rp => rp.package)
    this.reservationPackagesById = this.reservation.reservations_packages
      .reduce((obj, rp) => ({...obj, [rp.package_id]: rp}), {})

    const notCancelledVisits = this.visits.filter (visit => visit.visit_status_id != this.VisitStatuses.CANCELLED)
    const visitsDetails = notCancelledVisits.flatMap(v => v.visit_details)
    this.visitsDetailsByPackageId = window._.groupBy(visitsDetails, 'package_id')
    this.visit.packages = this.packageRemainders()
    this.initGUI()
  },
  methods: {
    getUnitMeasurementName (id) {
      const unitMeasurement = this.unitMeasurements.find(id)
      return unitMeasurement ? unitMeasurement.name : ''
    },
    getRoomName() {
      const room = this.rooms.find(room => room.id === this.visit.room_id) 
      return room ? room.name : '-'
    },
    getDoctorName() {
      const doctor = this.doctors.find(doctor => doctor.id === this.visit.doctor_id)
      return doctor ? doctor.user.name : '-'
    },
    packageRemainders() {
      const remainders = [];
      this.packages.forEach(p => {
        const packageTotalQuantity = Number(p.quantity) * Number(this.reservationPackagesById[p.id].repeated)
        
        let currentVisitUsage = this.totalUsedQuantities(this.visit.packages, p.id)
        // Calculate all used quantities except the quantities related to current visit because it calculated 
        // in currentVisitUsage constant
        const currentPackageVisitsDetails = this.visitsDetailsByPackageId[p.id]
        
        const visitDetails = currentPackageVisitsDetails ?
          currentPackageVisitsDetails.filter(vd => vd.visit_id != this.visit.id) : []

        let remainder = 
          packageTotalQuantity - this.totalUsedQuantities(visitDetails, p.id) - currentVisitUsage
        if (!this.UnitMeasurements.QUANTITIVE.includes(this.unitMeasurements.find(p.unit_measurement_id).name)) {
          if (remainder < 0 ) {
            remainder = 0 
            currentVisitUsage = packageTotalQuantity - this.totalUsedQuantities(visitDetails, p.id)
          }
        }

        remainders.push({
          package_id: p.id,
          unit_measurement_id: p.unit_measurement_id,
          entity_unit_measurement_id: p.entity_unit_measurement,
          name: p.name,
          remainder: remainder,
          quantity: currentVisitUsage
        })
      })

      return remainders
    },
    setPackages(){
      this.visit.packages = this.packageRemainders()
    },
    initGUI () {
      this.$nextTick(() => {
        $('#clinic-search').dropdown();
        $('#doctor-search').dropdown();
        $('#room-search').dropdown();

      })
    },
    totalUsedQuantities(visitDetails, packageId) {
      return window._.sumBy(visitDetails, vd => {
        if (packageId === vd.package_id) {
          return Number(vd.quantity)
        }

        return 0
      })
    },
    isAbleToAddActualQuantity(selectedPackage) {
      return !this.UnitMeasurements.QUANTITIVE.includes(this.unitMeasurements.find(selectedPackage.unit_measurement_id).name) &&
        this.UnitMeasurements.QUANTITIVE.includes(this.unitMeasurements.find(selectedPackage.entity_unit_measurement_id).name) &&
        this.visit.started_at
    },
    getStyle(remainder) {
      if (remainder < 0 ) {
        return { color: "red" };
      }

      return { color: "black" };
    },
    packageIsAllowedToReserve(selectedPackage) {
      return this.paidPackageIds.includes(selectedPackage.package_id) || !this.settings[1].value
    }
  },
}
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/visits/VisitForm.vue